import { http_client } from '@/plugins/http_client';

const url = 'api/solicitudes';

const getTipoRenuncias = async () =>
  await http_client(`${url}/tipo-renuncia`);

const getTipoProceso = async () => await http_client(`${url}/proceso`);

const getDecretos = async () => await http_client(`${url}/decretos`);

export default {
  getTipoRenuncias,
  getTipoProceso,
  getDecretos
};
